import { useContext } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import Login from '../../pages/login/Login'
import { GlobalContext } from '../../context/Context'
import MySpaceLayout from '../../pages/my_space'
import Overview from '../../pages/my_space/overview'
import PPCLayout from '../../pages/ppc'
import PPCOrganizationLayout from '../../pages/ppc/organization'
import PPCOrgOverview from '../../pages/ppc/organization/overview'
import PPCDataLayout from '../../pages/ppc-data'
import PPCDataOrganizationLayout from '../../pages/ppc-data/organization'
import PPCPerformanceLayout from '../../pages/performance'
import PPCPerformanceOrganizationLayout from '../../pages/performance/organization'
import PlatformList from '../../pages/ppc-data/organization/platforms'
import UserPerformanceList from '../../pages/performance/organization/user-performance'
import PPCDataList from '../../pages/ppc-data/organization/data'
import ServiceList from '../../pages/ppc-data/organization/services'
import BrandList from '../../pages/ppc-data/organization/brand'
import DeviceList from '../../pages/ppc-data/organization/devices'
import PerformanceList from '../../pages/performance/organization/performance'
import BrandOrganizationList from '../../pages/setting/organization/list'
import SettingLayout from '../../pages/setting'
import SettingOrganizationLayout from '../../pages/setting/organization'
import WebsitePerformance from '../../pages/ppc-data/organization/website-performance'
import PlatformPerformance from '../../pages/ppc-data/organization/platform-performance'
import DevicePerformance from '../../pages/ppc-data/organization/device-performance'
import InsightMatrices from '../../pages/ppc/organization/insight-matrices'
import PPCComparisionsLayout from '../../pages/comparisions'
import ComparisionLayout from '../../pages/comparisions/comparisions'
import ComparisionProduct from '../../pages/comparisions/comparisions/product'
import ComparisionWebsite from '../../pages/comparisions/comparisions/website'
import SummaryLayoutNew from '../../pages/summary'
import SummaryPlatformLayout from '../../pages/summary/platform'
import PlatformSummaryList from '../../pages/summary/platform/platforms'
import PPCProductSummary from '../ppc-summary-inner-pages/product-summary'
import PPCWebsiteSummary from '../ppc-summary-inner-pages/website-summary'
import PPCPlatformSummary from '../ppc-summary-inner-pages/platform-summary'
import PPCDeviceSummary from '../ppc-summary-inner-pages/device-summary'
import ProductSummaryLayout from '../../pages/summary/product'
import ProductSummaryList from '../../pages/summary/product/products'
import SummaryDeviceLayout from '../../pages/summary/device'
import DeviceBrandList from '../../pages/summary/device/brands'
import DeviceProductList from '../../pages/summary/device/products'

const MyRoutes = () => {
  let { state } = useContext(GlobalContext);
  const redirectUrl = sessionStorage.getItem("redirectUrl")
  return (
    <Routes>
      {(state?.isLogin === true) ? (
        <>
          {/* <Route path='/my-space' element={<MySpaceLayout />} >
            <Route path='overview' element={<Overview />} />

            <Route index element={<Navigate to="/my-space/overview" replace />} />
            <Route path="*" element={<Navigate to="/my-space/overview" replace />} />
          </Route> */}


          <Route path='/ppc' element={<PPCLayout />} >
            <Route path='organization' element={<PPCOrganizationLayout />}>
              <Route path='overview' element={<PPCOrgOverview />} />
              {(state.user?.user_role == 1 || state.user?.user_role == 2 || state.user?.user_role == 3) ?
                <Route path='insight-matrices' element={<InsightMatrices />} />
                :
                null
              }
            </Route>
          </Route>

          <Route path='/ppc-data' element={<PPCDataLayout />} >
            <Route path='organization' element={<PPCDataOrganizationLayout />}>
              <Route path='data' element={<PPCDataList />} />
              <Route path='services' element={<ServiceList />} />
              <Route path='brands' element={<BrandList />} />
              <Route path='devices' element={<DeviceList />} />
              <Route path='platforms' element={<PlatformList />} />
              <Route path='website-performance' element={<WebsitePerformance />} />
              <Route path='platform-performance' element={<PlatformPerformance />} />
              <Route path='device-performance' element={<DevicePerformance />} />
            </Route>
          </Route>

          {/* <Route path='/product-summary' element={<ProductSummaryLayout />} >
            <Route path='summary' element={<SummaryLayout />}>
              <Route path='products' element={<ProductSummaryList />} />
              <Route path='product-summary/:id' element={<PPCProductSummary />} />
              <Route path='website-summary/:id' element={<PPCWebsiteSummary />} />
              <Route path='platform-summary/:id' element={<PPCPlatformSummary />} />
              <Route path='device-summary/:id' element={<PPCDeviceSummary />} />
            </Route>
          </Route>

          <Route path='/platform-summary' element={<PlatformSummaryLayout />} >
            <Route path='summary' element={<SummaryPlatformLayout />}>
              <Route path='platforms' element={<PlatformSummaryList />} />
              <Route path='product-summary/:id' element={<PPCProductSummary />} />
              <Route path='website-summary/:id' element={<PPCWebsiteSummary />} />
              <Route path='platform-summary/:id' element={<PPCPlatformSummary />} />
              <Route path='device-summary/:id' element={<PPCDeviceSummary />} />
            </Route>
          </Route>

          <Route path='/device-summary' element={<DeviceSummaryLayout />} >
            <Route path='summary' element={<SummaryDeviceLayout />}>
              <Route path='brands' element={<DeviceBrandList />} />
              <Route path='products' element={<DeviceProductList />} />
              <Route path='product-summary/:id' element={<PPCProductSummary />} />
              <Route path='website-summary/:id' element={<PPCWebsiteSummary />} />
              <Route path='platform-summary/:id' element={<PPCPlatformSummary />} />
              <Route path='device-summary/:id' element={<PPCDeviceSummary />} />
            </Route>
          </Route> */}

          <Route path='/summary' element={<SummaryLayoutNew />} >
            <Route path='platform' element={<SummaryPlatformLayout />}>
              <Route path='platforms' element={<PlatformSummaryList />} />
              <Route path='product-summary/:id' element={<PPCProductSummary />} />
              <Route path='website-summary/:id' element={<PPCWebsiteSummary />} />
              <Route path='platform-summary/:id' element={<PPCPlatformSummary />} />
              <Route path='device-summary/:id' element={<PPCDeviceSummary />} />
            </Route>

            <Route path='product' element={<ProductSummaryLayout />}>
              <Route path='products' element={<ProductSummaryList />} />
              <Route path='product-summary/:id' element={<PPCProductSummary />} />
              <Route path='website-summary/:id' element={<PPCWebsiteSummary />} />
              <Route path='platform-summary/:id' element={<PPCPlatformSummary />} />
              <Route path='device-summary/:id' element={<PPCDeviceSummary />} />
            </Route>

            <Route path='device' element={<SummaryDeviceLayout />}>
              <Route path='brands' element={<DeviceBrandList />} />
              <Route path='products' element={<DeviceProductList />} />
              <Route path='product-summary/:id' element={<PPCProductSummary />} />
              <Route path='website-summary/:id' element={<PPCWebsiteSummary />} />
              <Route path='platform-summary/:id' element={<PPCPlatformSummary />} />
              <Route path='device-summary/:id' element={<PPCDeviceSummary />} />
            </Route>
            
          </Route>


          <Route path='/ppc-comparision' element={<PPCComparisionsLayout />} >
            <Route path='comparision' element={<ComparisionLayout />}>
              <Route path='products' element={<ComparisionProduct />} />
              <Route path='websites' element={<ComparisionWebsite />} />
            </Route>
          </Route>

          <Route path='/performance' element={<PPCPerformanceLayout />} >
            <Route path='organization' element={<PPCPerformanceOrganizationLayout />}>
              <Route path='performance' element={<PerformanceList />} />
              <Route path='user-performance' element={<UserPerformanceList />} />
            </Route>
          </Route>

          <Route path='/setting' element={<SettingLayout />} >
            <Route path='organization' element={<SettingOrganizationLayout />}>
              <Route path='brands' element={<BrandOrganizationList />} />
            </Route>
          </Route>


          <Route path="*" element={<Navigate to="/ppc/organization/overview" replace />} />
        </>
      )
        :
        (state?.isLogin === false) ?
          <>
            <Route path='/login' element={<Login />} />
            <Route path='*' element={<Navigate to={'/login'} />} />
          </>
          :
          <></>
      }

    </Routes>
  )
}

export default MyRoutes